<template>
	<form class="item-editor-form">
		<fg-input v-model="item.id" :label="$t('users.id')" :disabled="action == 'item'"></fg-input>
		<fg-input v-model="password"
            :label="$t('users.password')"
            v-validate="'required|min:6'"
            name="password"
            type="password"
            ref="password">
        </fg-input>
		<fg-input v-model="passwordConfirmation"
            v-validate="'required|confirmed:password'"
            name="passwordConfirmation"
            type="password"
            data-vv-as="password"
            :label="$t('users.password_confirmation')" >
        </fg-input>
		<fg-input v-model="item.firstname" :label="$t('users.firstname')" ></fg-input>
		<fg-input v-model="item.lastname" :label="$t('users.lastname')"></fg-input>
		<fg-input v-model="item.email" :label="$t('users.email')"></fg-input>
		<fg-input v-model="item.mobile" :label="$t('users.mobile')"></fg-input>
		<label for="organisation">{{ $t('users.org') }}:</label>
		<organisationSelect v-model="item.organisation" id="organisation" />
		<UsersAvailableGroups v-model="item.availableUserGroups" />
		<div class="alert alert-danger" v-if="showErrors && (errors.has('password') || errors.has('passwordConfirmation') || !passwordOk || (!idOk && getIdErrorMsg()))">
			{{ errorMsg }}
            {{ getIdErrorMsg() }}
		</div>

		<FormButtons
			@submit="submit"
			:submit="$UIPrivilegeUpdate('system', 'users')"
			:reset="false"
			:remove="action == 'item' && $UIPrivilegeDelete('system', 'users')"
			:itemid="item.id"
			:disableSubmit="!passwordOk || !idOk"
			@remove="remove"
		>
		</FormButtons>

		<RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
	</form>
</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import organisationSelect from '@/components/Timetable/OrganisationSelect'
import UsersAvailableGroups from '@/components/System/UsersAvailableGroups'

export default {
	components: { FormButtons, organisationSelect, UsersAvailableGroups },
	props: {
		item: { default: {} },
		action: { default: 'new' },
		passwordMinLength: { default: 6 },
	},
	data() {
		return {
			password: null,
			passwordConfirmation: null,
			passwordOk: true,
			ok: false,
			error: false,
			loading: false,
			infoType: 'save',
			errorMsg: '',
			showErrors: true,
		}
	},
	watch: {
		item() {
			if (this.action === 'item') {
				this.password = this.passwordConfirmation = null
				this.passwordOk = true
				this.showErrors = false
			}
		},
		password() {
			this.checkPasswords()
		},
		passwordConfirmation() {
			this.checkPasswords()
		},
	},
    computed: {
        idOk() {
            if (this.action == 'item') {
                return true;
            }
            if (!this.item || !this.item.id) {
                return false;
            }
            for (const usr of this.$store.state.userDataHandler.users.list) {
                if (this.item.id == usr.id) {
                    return false;
                }
            }
            return true;
        }
    },
	methods: {
		checkPasswords() {
			this.passwordOk =
				(!this.passwordConfirmation && !this.password) ||
				(this.password === this.passwordConfirmation &&
					this.password.length >= this.passwordMinLength)

			if (!this.passwordOk) {
				this.showErrors = true
				this.errorMsg =
					this.password && this.password.length < this.passwordMinLength
						? this.$t('users.password_too_short')
						: !this.passwordOk
						? this.$t('users.password_mismatch')
						: ''
			} else this.showErrors = false
		},
		submit() {
			if (event) event.preventDefault()

			this.ok = this.error = false
			this.infoType = 'save'
			this.loading = true
			this.item.password = this.password

			setTimeout(() => {
				this.$store
					.dispatch('userDataHandler/updateUser', this.item)
					.then((response) => {
						this.ok = response.data.errorCode == 0
						this.error = !this.ok
					})
					.catch(() => {
						this.error = true
					})
					.finally(() => {
						this.loading = false
					})
			}, 1000)
		},
		reset(event) {
			event.preventDefault()
		},
		remove() {
			this.infoType = 'delete'
			this.loading = true

			setTimeout(() => {
				this.$store
					.dispatch('userDataHandler/deleteUser', this.item.id)
					.then((response) => {
						this.ok = response.data.errorCode == 0
						this.error = !this.ok
					})
					.catch(() => {
						this.error = true
					})
					.finally(() => {
						this.loading = false
					})
			}, 1000)
		},
        getIdErrorMsg() {
            if (this.errorMsg || !this.item || !this.item.id) {
                return '';
            }
            return this.$t('users.id_already_in_use');
        }
	},
}
</script>
